// extracted by mini-css-extract-plugin
export default {"grid":"OurStory_grid__dsD3q","title":"OurStory_title__ZzZY-","vision":"OurStory_vision__Y5glW","panel":"OurStory_panel__zq8cm","invitation":"OurStory_invitation__cTT4f"};